/**
 * Roles with an enterprise (org-scoped) Role Description Page. Any other role slug is consumer-only:
 * the enterprise org-scoped page redirects to /career-academy/roles/:slug.
 */
const ENTERPRISE_CAREER_ACADEMY_ROLE_SLUGS = new Set<string>([
  'data-manager',
  'python-developer',
  'graphic-designer',
  'junior-software-developer',
  'content-creator',
  'business-analyst',
  'medical-office-manager',
  'medical-biller',
  'public-relations-specialist',
  'mobile-app-developer',
  'program-manager',
  'personal-trainer',
  'insurance-sales-agent',
  'game-designer',
  'product-manager',
  'data-analyst',
  'project-manager',
  'cybersecurity-analyst',
  'ux-designer',
  'it-support-specialist',
  'digital-marketer',
  'data-scientist',
  'bookkeeper',
  'front-end-developer',
  'social-media-specialist',
  'supply-chain-analyst',
  'business-intelligence-analyst',
  'application-developer',
  'human-resources-specialist',
  'data-engineer',
  'back-end-developer',
  'full-stack-developer',
  'devops-software-engineer',
  'payroll-specialist',
  'compensation-analyst',
  'cloud-support-associate',
  'technology-consultant',
  'sales-ops-support-specialist',
  'ios-developer',
  'marketing-analyst',
  'it-project-manager',
  'android-developer',
  'sales-development-representative',
  'career-coach',
  'data-warehousing-specialist',
  'network-engineer',
  'customer-service-representative',
  'solutions-architect',
  'real-estate-agent',
  'sales-representative',
  'recruiter',
  'systems-analyst',
  'health-coach',
]);

/** Returns true if the slug has an enterprise (org-scoped) Role Description Page. */
export const isEnterpriseCareerAcademyRoleSlug = (slug: string | null | undefined): boolean =>
  !!slug && ENTERPRISE_CAREER_ACADEMY_ROLE_SLUGS.has(slug);

/** Builds the consumer role page URL for a role slug. */
export const getConsumerRoleUrl = (roleSlug: string) => `/career-academy/roles/${roleSlug}`;
